<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/1_1.jpeg/1_1.webp';
import Img2 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/1_2.jpeg/1_2.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      <strong
        >2人に1人がマイホームを所有。世帯年収600万円を超えると過半数がマイホームを購入</strong
      >
    </template>

    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          調査対象者のマイホーム所有率は53.4%で、
          <strong>2人に1人がマイホームを所有</strong
          >していることがわかりました。
        </p>
        <p>
          また、現在所有していないものの、<strong>将来は所有したいと回答した方は26.9％（「現在所有しておらず、将来は所有したいと思い、検討を始めている」8.2%「現在所有しておらず、将来は所有したいが、検討は始めていない」18.7%）</strong>という結果となりました。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img2" alt="グラフ" />
      <div>
        <p>
          世帯年収別で見ると「既にマイホームを所有している」方は、400万円未満43.0%、400万円以上600万円未満43.4%、600万円以上800万円未満57.6%、800万円以上1,000万円未満63.7％、1,000万円以上1,200万円未満69.7%、1,200万円以上74.6%と、世帯年収が高くなるほどマイホーム所有率が高くなっており、
          <strong
            >世帯年収600万円を超えるとマイホーム所有率が過半数を超える結果</strong
          >となりました。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
